import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const ShortLinkRedirectPage = () => {
  const { code } = useParams();

  useEffect(() => {
    const safeCode = String(code || '').trim();
    if (!safeCode) return;
    window.location.replace(`/api/public/x/${encodeURIComponent(safeCode)}`);
  }, [code]);

  return (
    <div style={{ padding: 24, textAlign: 'center', fontFamily: 'sans-serif' }}>
      Yönlendiriliyor…
    </div>
  );
};

export default ShortLinkRedirectPage;
